import { useMutation } from '@tanstack/react-query';

import { api } from '@app/utils/api';
import { errorHandler } from '@app/utils/errorHandler';
import { AUTH_BASE_URL } from '@app/contstants/endpoints';

interface ILoginPayload {
  username: string;
  password: string;
}

export const login = async ({
  username,
  password,
}: ILoginPayload): Promise<{ access_token: string }> => {
  const response = await api.post<{ access_token: string }>(
    `${AUTH_BASE_URL}/auth/api/v1/login`,
    {
      username,
      password,
    },
    {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }
  );

  return response.data ?? [];
};

export const useLogin = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: login,
    onError: error => errorHandler(error),
  });

  return {
    login: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
